import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import Header from '../common/components/Header';
import userManager from '../utils/userManager';

class SchedulerHeader extends Component {

  goBack = () => {
    const { location } = this.props.history;
    let prevPath = "";
    if (location.state && location.state.prevPath) {
      prevPath = location.state.prevPath;
    }
    this.props.history.push(prevPath);
  }

  logout = () => {
    userManager.signoutRedirect({ 'id_token_hint': this.props.user.user_id }).catch(e => console.log(e))
    userManager.removeUser();
  }

  render() {
    const { residentName } = this.props.session
    return (
      <Header
        rezydent={residentName}
        tripsHeader={false}
        logout={this.logout}
        goBack={this.goBack}
        location={this.props.location}
        user={this.props.user}
      >
      </Header>
    )
  }
}

export default compose(
    withRouter,
    connect(state => ({ 
        session: state.session,
        user: state.oidc.user 
    }), {})
)(SchedulerHeader)
